var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditRulesIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4038 4.75736L16.4038 6.75736V2H7.40381V7H2.40381V18H16.4038V15.2426L18.4038 13.2426V19.0082C18.4038 19.556 17.9589 20 17.4104 20H1.39721C0.848569 20 0.403809 19.5501 0.403809 18.9932V6L6.407 0H17.4016C17.9551 0 18.4038 0.45531 18.4038 0.9918V4.75736ZM19.182 6.80761L20.5962 8.2218L12.818 16L11.4017 15.9979L11.4038 14.5858L19.182 6.80761Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRulesIconNew);
export default __webpack_public_path__ + "static/media/editRulesIconNew.2c4f9fb8.svg";
export { ForwardRef as ReactComponent };